import React from 'react';
import { SELECT_BANK_VIEW } from './bankModalView';
import type { Bank } from '../../../common/models/banks/bank';

type Props = {
  banks: Array<Bank>;
  onTransition: (view: number) => void;
  onChangeBank: (bank: Bank) => void;
  onCancel: () => void;
};

export default function PopularBanksView({
  banks,
  onCancel,
  onChangeBank,
  onTransition,
}: Props) {
  return (
    <div className="modal-dialog modal-lg">
      <div className="modal-content">
        <div className="modal-header text-center">
          <h5 className="modal-title w-100">金融機関を選択</h5>
          <span className="material-symbols-outlined close" onClick={onCancel}>
            <span>&times;</span>
          </span>
        </div>
        <div className="modal-body p-40">
          <div className="row mb-30">
            {banks
              .filter(b => b.isPopular)
              .map(b => {
                return (
                  <div className="col-md-4 mb-20" key={b.id}>
                    <button
                      type="button"
                      className="btn btn-lg btn-block btn-flat btn-outline-primary"
                      onClick={() => onChangeBank(b)}
                    >
                      {b.name}
                    </button>
                  </div>
                );
              })}
          </div>
          <button
            type="button"
            className="btn btn-lg btn-block btn-flat btn-outline-primary"
            onClick={() => onTransition(SELECT_BANK_VIEW)}
          >
            ご利用の銀行がこの中にない場合
          </button>
        </div>
      </div>
    </div>
  );
}
